module.exports = __webpack_public_path__ + "static/media/0319_Medium.3132addf.jpg";